import React from 'react';

export default function ScannerError({ error }) {
  if (!error) return null;
  return (
    <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4" data-testid="scanner-error">
      <p className="text-sm text-red-800">
        <strong>⚠️ Error:</strong> {error}
      </p>
    </div>
  );
}
